const DesktopHomeFeedback = () => {
  return (
    <div className="mx-auto mb-[218px] hidden w-[1360px] max-w-full flex-col justify-center lg_flex">
      <p className="mb-[48px] text-center text-[48px] font-[700] leading-[58px] text-title">
        Feedback from Titto community
      </p>
      <div className="grid grid-cols-3 gap-[56px]">
        <div className="overflow-hidden rounded-[24px] bg-white">
          <div className="p-[24px]">
            <p className="mb-[24px] min-h-[54px] text-left text-[24px] font-[700] leading-[28px] text-title">
              What a fascinating bird-watching experience!
            </p>
            <p className="mb-[24px] leading-[22px] text-[#3E3E3E]">
              I love receiving notifications whenever a new bird visits, and the
              high-resolution camera captures stunning photos that I can easily
              share with my friends.
            </p>
            <div className="flex items-center justify-between">
              <img className="h-[36px] w-auto" src="/icons/five-star.svg" />
              <img
                className="h-[64px] w-[64px]"
                src="/images/home-avatar-1.webp"
              />
            </div>
          </div>
        </div>
        <div className="overflow-hidden rounded-[24px] bg-white">
          <div className="p-[24px]">
            <p className="mb-[24px] min-h-[54px] text-left text-[24px] font-[700] leading-[28px] text-title">
              Incredibly weather -resistant!{" "}
            </p>
            <p className="mb-[24px] leading-[22px] text-[#3E3E3E]">
              It has withstood heavy rain and strong winds without issues. The
              long standby time means I rarely need to recharge it. Overall,
              it's a fantastic addition to my garden.
            </p>
            <div className="flex items-center justify-between">
              <img className="h-[36px] w-auto" src="/icons/five-star.svg" />
              <img
                className="h-[64px] w-[64px]"
                src="/images/home-avatar-2.webp"
              />
            </div>
          </div>
        </div>
        <div className="overflow-hidden rounded-[24px] bg-white">
          <div className="p-[24px]">
            <p className="mb-[24px] min-h-[54px] text-left text-[24px] font-[700] leading-[28px] text-title">
              New world of birds!{" "}
            </p>
            <p className="mb-[24px] leading-[22px] text-[#3E3E3E]">
              Opened my eyes to a whole new world of bird behavior. With its
              AI-powered identification, I've learned to distinguish between
              species I never knew before.
            </p>
            <div className="flex items-center justify-between">
              <img className="h-[36px] w-auto" src="/icons/five-star.svg" />
              <img
                className="h-[64px] w-[64px]"
                src="/images/home-avatar-3.webp"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DesktopHomeFeedback
